import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftSecretSettingModal from '@draft/draft-secret-setting-modal';

import ContentsModal from 'contents_modal';
import ContentsTab   from 'contents_tab';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftFlow extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  dammyEvent() {
  }
  // -------------------------------------------------------
  
  render() {
    let draft_flow = this.props.draft_flow;
    let is_edit    = this.props.is_edit;
    let members    = this.props.members;
    let flow_no    = this.props.flow_no;
    if( flow_no    == undefined || flow_no == null ) flow_no = 1;
    let is_complete = this.props.is_complete;
    
    let set_ev = this.props.set_ev;
    if( set_ev == undefined ) set_ev = this.dammyEvent.bind(this);
    
    return (
      <div className="draft-flow">
        {(is_edit == true) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>担当者を追加する</Tooltip>}>
            <div className="edit" onClick={this.toggleModal.bind(this, true)}><i className="material-icons">edit</i>編集</div>
          </OverlayTrigger>
        }
        
        <div className="management-box">
          <h6>確認順</h6>
          
          {(draft_flow.length > 0) && 
            <ul className="management-accounts">
              { draft_flow.map((d, key) => {
                let no = (key + 1);
                
                let icon_design = 'off';
                if( no == flow_no && is_complete == false ) icon_design = 'now';
                if( no == flow_no && is_complete == true ) icon_design = 'complete';
                if( no <  flow_no ) icon_design = 'active';
                
                let flow_active = ( no > flow_no && is_complete == true ) ? 'deactive' : 'active';
                
                return (
                  <li key={key} className={flow_active}>
                    <i className={'material-icons base-icon '+ icon_design}>check_circle</i>
                    { (d.user != undefined) && <b>{no}. {d.user.name}<span className="email">({d.user.email})</span></b> }
                    { (d.guest_company != undefined) && <b>{no}. {d.guest_company.name}</b> }
                    
                    { (key < (draft_flow.length - 1)) && <i className={'material-icons down-icon '+ icon_design}>arrow_drop_down</i> }
                    
                    { (icon_design == 'complete') && <i className="complete-mark">確認完了</i> }
                    
                    {(this.props.detail_id != undefined && this.props.refresh_ev != undefined) &&
                      <DraftSecretSettingModal data={this.props.data} item={d} detail_id={this.props.detail_id} refresh_ev={this.props.refresh_ev.bind(this)} />
                    }
                  </li>
                );
              })}
            </ul>
          }
          
          { (draft_flow.length == 0) && <div className="none">確認担当者が登録されていません</div> }
        </div>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {600}
          height    = {500}
          close_ev  = {this.toggleModal.bind(this, false)}
          html      = {
            <div className="modal-item draft-management-modal">
              <EditModal draft_flow={draft_flow} flow_no={flow_no} members={members} set_ev={set_ev.bind(this)} template_ev={(this.props.template_ev != null) ? this.props.template_ev.bind(this) : null} />
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class EditModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal    : false,
      flow_idx : null,
      option   : {},
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg, flow_idx, option) {
    this.setState({ modal: flg, flow_idx: flow_idx, option: option });
  }
  // -------------------------------------------------------
  
  setFlow(value, mode) {
    this.props.set_ev.bind(this)(value, mode, this.state.flow_idx, this.state.option);
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  deleteFlow(name, flow_no) {
    let chk = confirm('「'+ name +'」さんを確認のメンバーから外してもよろしいですか？');
    if( chk == false ) return;
    
    this.props.set_ev.bind(this)('', 'delete', flow_no);
  }
  // -------------------------------------------------------
  
  render() {
    let draft_flow = this.props.draft_flow;
    let members    = this.props.members;
    let flow_no    = this.props.flow_no;
    
    return (
      <div className="draft-edit-modal">
        <h2>確認順の編集</h2>
        <ul className="management-accounts">
          { draft_flow.map((d, key) => {
            let no = (key + 1);
            
            let name = '';
            if( d.user != undefined ) name = d.user.name;
            if( d.user != undefined && (name == null || name == '' )) name = d.user.email;
            if( d.guest_company != undefined ) name = d.guest_company.name;
            
            let is_old_flow = (no < flow_no) ? 'is-old-flow' : 'active';
            let change_html = (flow_no <= no) ? <i className="change" onClick={this.toggleModal.bind(this, true, no, { change_type: 'update', change_id: d.id })}>変更</i> : null;
            
            return (
              <li key={key} className={is_old_flow}>
                { (d.user != undefined) && <b>{no}. {name}<span className="email">({d.user.email})</span>{change_html}</b> }
                { (d.guest_company != undefined) && <b>{no}. {d.guest_company.name}{change_html}</b> }
                
                { (key < (draft_flow.length - 1)) && <i className="material-icons down-icon">arrow_downward</i> }
                
                { (flow_no <= no) && 
                  <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{name}さんを確認担当から削除する</Tooltip>}>
                    <p className="delete-members" onClick={this.deleteFlow.bind(this, name, no)}><i className="material-icons">delete</i></p>
                  </OverlayTrigger>
                }
                { (flow_no <= (key + 2) && draft_flow.length > no) && <p className="add-members" onClick={this.toggleModal.bind(this, true, no, {})}><i className="material-icons">add</i>メンバーを追加</p> }
              </li>
            );
          })}
          
          {(draft_flow.length == 0) && <div className="member-none" /> }
          <li className="add"><p className="add-members" onClick={this.toggleModal.bind(this, true, (draft_flow.length + 1), {})}><i className="material-icons">add</i>メンバーを追加</p></li>
        </ul>
        
        { (this.props.template_ev !== undefined && this.props.template_ev !== null) &&
          <div className="template-button" onClick={this.props.template_ev.bind(this)}>
            テンプレートを適用
          </div>
        }
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {500}
          height    = {250}
          close_ev  = {this.toggleModal.bind(this, false)}
          html      = {
            <div className="modal-item draft-management-modal">
              <MemberSelectModal members={members} set_ev={this.setFlow.bind(this)} />
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class MemberSelectModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_active: false,
      value    : null,
      mode     : null,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    console.log(this.props);
  }
  // -------------------------------------------------------
  
  submit() {
    this.props.set_ev.bind(this)(this.state.value, this.state.mode);
  }
  // -------------------------------------------------------
  
  change(value, mode) {
    this.setState({ is_active: (value != 'null'), value: value, mode: mode });
  }
  // -------------------------------------------------------
  
  render() {
    let members = this.props.members;
    
    let tabs = [
      { id: 'my',             name: '社内アカウント',    html: <MemberSelect members={members} change_ev={this.change.bind(this)} mode="my_members" /> },
      { id: 'guest_company',  name: 'ゲスト会社',        html: <MemberSelect members={members} change_ev={this.change.bind(this)} mode="guest_companys" /> },
      { id: 'guest',          name: 'ゲストアカウント',  html: <MemberSelect members={members} change_ev={this.change.bind(this)} mode="guest_members" /> },
    ];
    
    return (
      <div className="draft-flow-modal">
        <h2>確認担当者の追加</h2>
        
        <ContentsTab tabs={tabs} font_size={16} />
        
        { (this.state.is_active == true)
          ? <div className="button" onClick={this.submit.bind(this)}>登録</div>
          : <div className="button off">登録</div>
        }
        
      </div>
    );
  }
}
// -------------------------------------------------------

class MemberSelect extends React.Component {
  change(value) {
    this.props.change_ev.bind(this)(this.item.value, this.props.mode);
  }
  
  render() {
    let members = this.props.members[this.props.mode];
    
    return (
      <div className="selectbox">
        <select ref={(input) => { this.item = input }} onChange={this.change.bind(this)}>
          { (members.length > 0)
            ? <option value="null">確認担当者を選択してください</option>
            : <option value="null">登録できる対象が見つかりません</option>
          }
          
          { members.map((d, key) => {
            return <option key={key} value={d.id}>{d.name}{(d.email != undefined) && ' ('+ d.email +')'}</option>
          })}
        </select>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftFlow;